import { connect } from 'react-redux'
import CreateApplication from 'components/Applicants/CreateApplication'
import {getFmcsaData, getApplicantsById, createApplication, resetFmcsaData} from 'actions/applicants'
import { dispatchNotification, getSalesRepresentatives } from 'actions/root'
import { DefaultApplicationForm } from 'constants/application'
import { updateInitialValuesWithSosData } from 'constants/utilityFunctions'
import { cloneDeep } from 'lodash'

function mapCountryCode(countryCode) {
    switch (countryCode) {
        case 'US':
            return 'USA'
        case 'CA':
            return 'CAN'
        case 'MX':
            return 'MEX'
        default:
            return countryCode || ''
    }
}


function mapStateToProps(stateProps, ownProps) {
    const { location } = ownProps
    const { globalAccountSelected, refreshApplicant } = stateProps?.root
    const { applicantById, fmcsaData, extraContent, uuid, sosData } = stateProps?.applicant
    const hideFmcsa = stateProps?.user?.userDetails?.securityContext?.client?.hideFmcsa || false;
    const showFactorCloudOnboardCheckbox = stateProps?.user?.userDetails?.securityContext?.client?.factorCloudConfigured || false;
    const formValues = stateProps?.form?.applicationForm?.values
    const search = new URLSearchParams(location.search)
    const codeType = search.get('codeType')
    const codeValue = search.get('codeValue')
    const storedCarrier = fmcsaData[0]?.carrier
    const selectedCarrier = codeType !== 'DOT' ||
        (fmcsaData.length === 1 && String(storedCarrier?.dotNumber) === String(codeValue))
        ? storedCarrier
        : undefined
    const {
        legalName,
        phyStreet,
        phyCity,
        phyCountry,
        phyState,
        phyZipcode,
        ein,
        dotNumber,
        dbaName
    } = selectedCarrier || {}
    const sosSearch = search.get('sosSearch')
    const source = search.get('source')
    let initialValues = cloneDeep(DefaultApplicationForm)

    if (sosSearch) {
        initialValues = updateInitialValuesWithSosData(initialValues, sosData);
    }


// Pre-fill from Motus data passed via router state
    if (source === 'motus' && location.state?.motusData) {
        const motus = location.state.motusData
        initialValues.business.name = motus.name || ''
        initialValues.business.dbaName = motus.dbaName || ''
        initialValues.business.dotNumber = motus.dotNumber || ''
        initialValues.business.addresses[0].address1 = motus.address1 || ''
        initialValues.business.addresses[0].city = motus.city || ''
        initialValues.business.addresses[0].state = motus.state || initialValues.business.addresses[0].state
        initialValues.business.addresses[0].zip5 = motus.zip5 || ''
        initialValues.business.addresses[0].countryCode = mapCountryCode(motus.country)
        initialValues.motusDotSearchUuid = motus.motusDotSearchUuid || null

        // Pre-fill email
        if (motus.email) {
            initialValues.business.emails[0].email = motus.email
        }

        // Pre-fill owners from officers
        if (motus.officers && motus.officers.length > 0) {
            initialValues.owners = motus.officers.map(officer => ({
                firstName: (officer.firstName || '').trim(),
                lastName: (officer.lastName || '').trim(),
                title: officer.title || '',
                address: {
                    address1: '',
                    address2: '',
                    city: '',
                    state: 'AL',
                    zip5: '',
                    addressType: 'Home',
                    countryCode: 'USA'
                },
                emails: [{ email: officer.email || '', emailType: 'Work', primary: true }],
                identifications: [{ identification: '', identificationType: 'SSN', primary: true }],
                phones: [{ number: officer.phoneNumber || '', phoneType: 'Work', primary: true }]
            }))
        }
    }

    if (codeType) {
        let business = initialValues.business
        initialValues.business.name = legalName
        business.dotNumber = dotNumber
        business.dbaName = dbaName || legalName
        business.addresses[0].address1 = phyStreet
        business.addresses[0].countryCode = mapCountryCode(phyCountry)
        business.addresses[0].state = phyState
        business.addresses[0].city = phyCity
        business.addresses[0].zip5 = phyZipcode
        business.identifications[0].identification = ein
        business.mcNumber = extraContent?.mcNumbers && extraContent?.mcNumbers[0]
    }
    initialValues.fmcsaInteractionResponseUuid = uuid
    initialValues.fmcsaBasicUuid = extraContent?.basicSearchUuid
    initialValues.fmcsaAuthorityUuid = extraContent?.authoritySearchUuid
    initialValues.fmcsaMcNumberUuid = extraContent?.mcNumberSearchUuid
    initialValues.fmcsaCargoCarriedUuid = extraContent?.cargoSearchUuid
    initialValues.fmcsaOperationClassificationUuid = extraContent?.operationSearchUuid
    initialValues.fmcsaInteractionResponseUuid = uuid
    // debtor
    let debtor = initialValues.debtor
    debtor.identifications[0].identification = ein
    return {
        initialValues: { ...initialValues },
        globalAccountSelected,
        fmcsaData: selectedCarrier,
        refreshApplicant,
        applicant: applicantById,
        codeType,
        codeValue,
        formValues,
        ein,
        dbaName,
        hideFmcsa,
        showFactorCloudOnboardCheckbox
    }
}

function mergeProps(stateProps, dispatchProps, ownProps) {
    return {
        ...stateProps,
        ...ownProps,
        ...dispatchProps,
    }
}

export default connect(
    mapStateToProps,
    {
        getFmcsaData,
        getApplicantsById,
        dispatchNotification,
        createApplication,
        getSalesRepresentatives,
        resetFmcsaData
    },
    mergeProps
)(CreateApplication)